import { ROUTE_NAME } from '@constants';

const PrivacyPolicy = {
  path: '/use-information',
  redirect: '/use-information/privacy-policy',
  meta: {
    // isDesktop: false,
    breadcrumb: true,
    breadcrumbName: '개인정보취급방침',
    navMenu: true,
    description: '송추 컨트리클럽의 개인정보 보호책임입니다.',
  },
  children: [
    {
      name: ROUTE_NAME.PrivacyPolicy,
      path: 'privacy-policy',
      component: () => import('@views/use-information/PrivacyPolicy.vue'),
      meta: {
        breadcrumb: true,
        breadcrumbName: '개인정보취급방침',
      },
    },
  ],
};
export default PrivacyPolicy;
